import { Icons } from '@commenda/kakashi';
import { Country } from 'country-state-city';
import { SummaryFieldKS } from '../../common/SummaryFieldKS';

type TBusinessDetailsProps = {
  requestData: {
    businessDescription: string;
    businessActivity: string[];
    estimatedAnnualTurnover: number;
    exportCountries: string[];
    importCountries: string[];
  };
  hideActionButtons?: boolean;
  setActiveStep: (itemIndex: number) => void;
};

export const SummaryBusinessDetails = ({
  requestData,
  hideActionButtons = false,
  setActiveStep,
}: TBusinessDetailsProps) => {
  const exportCountries = requestData?.exportCountries
    .map((eachCountry) => Country.getCountryByCode(eachCountry)?.name)
    .join(', ');

  const importCountries = requestData?.importCountries
    .map((eachCountry) => Country.getCountryByCode(eachCountry)?.name)
    .join(', ');

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <h4 className="body-16-bold text-text-primary">Business Details</h4>
        {hideActionButtons ? null : (
          <Icons.Edit01
            className="cursor-pointer"
            onClick={() => setActiveStep(0)}
          />
        )}
      </div>
      <div className="flex flex-col gap-3 bg-bg-disabled-subtle rounded-sm">
        <div className="flex flex-col gap-2 p-6">
          {requestData?.businessDescription ? (
            <SummaryFieldKS
              heading="Business description"
              value={requestData.businessDescription}
            />
          ) : null}
          {requestData?.businessActivity ? (
            <SummaryFieldKS
              heading="Business activities"
              value={requestData.businessActivity.join(', ')}
            />
          ) : null}

          {requestData?.estimatedAnnualTurnover ? (
            <SummaryFieldKS
              heading="Estimated Annual Turnover"
              value={`AED ${requestData?.estimatedAnnualTurnover}`}
            />
          ) : null}
          {requestData?.exportCountries ? (
            <SummaryFieldKS
              heading="What countries do you plan to sell goods and services to?"
              value={exportCountries}
            />
          ) : null}
          {requestData?.importCountries ? (
            <SummaryFieldKS
              heading="What countries will supply your goods/services?"
              value={importCountries}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};
